/*Acá se van agregando los tipos de formularios que existen
y luego se realiza un mapeo con código para mostrar uno u otro tipo de formulario*/

const formTypeMap = {
    "FormMonserratSchool"           :"MS",
    "FormMonserratPregrade"         :"MPSC",
    "FormMonserratSchoolCovid"      :"MS"

}

module.exports = formTypeMap;
